/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultTrustListPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultTrustListPaginationFilter = {
	$skip: defaultTrustListPagination.$skip,
	$limit: defaultTrustListPagination.$limit,
};

const defaultCareSpecalitiesPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultCareSpecalitiesPaginationFilter = {
	$skip: defaultCareSpecalitiesPagination.$skip,
	$limit: defaultCareSpecalitiesPagination.$limit,
};
const defaultTrustFeaturePagination = {
	total: 100,
	$skip: 0,
	$limit: 5,
};
const defaultTrustFeaturePaginationFilter = {
	$skip: defaultTrustFeaturePagination.$skip,
	$limit: defaultTrustFeaturePagination.$limit,
};
const defaultTrustAdminPagination = {
	total: 100,
	$skip: 0,
	$limit: 5,
};
const defaultTrustAdminPaginationFilter = {
	$skip: defaultTrustAdminPagination.$skip,
	$limit: defaultTrustAdminPagination.$limit,
};

export default {
	state: {
		trustSummaryData: {
			name: '',
			isLive: false,
			abbreviatedName: '',
			profileUrl: '',
			description: '',
			phoneNumber: '',
			email: '',
			users: [],
			features: [],
		},
		trusts: [],
		trustListPagination: defaultTrustListPagination,
		trustListFilter: defaultTrustListPaginationFilter,
		currentTrustId: null,
		careLoactionFeatures: [],
		trustCareSpecialitiesList: [],
		trustFeatureList: [],
		trustAdminList: [],
		trustCareSpecialitiesListPagination: defaultCareSpecalitiesPagination,
		trustCareSpecialitiesListPaginationFilter: defaultCareSpecalitiesPaginationFilter,
		trustFeatureSetupPagination: defaultTrustFeaturePagination,
		trustFeatureSetupPaginationFilter: defaultTrustFeaturePaginationFilter,
		trustAdminSetupPagination: defaultTrustAdminPagination,
		trustAdminSetupPaginationFilter: defaultTrustAdminPaginationFilter,
		disableCreate: {
			isfirstStepAllowed: false,
			isSecondStepAllowed: false,
			isFinalStepAllowed: false,
		},
		globalFeaturelist: [],
		isSwitching: false,
	},
	getters: {
		trustListPage: (state) => {
			const { $limit, $skip } = state.trustListPagination;
			return $skip / $limit + 1;
		},
		trusts: (state) => state.trusts,
		currentTrustId: (state) => state.currentTrustId,
		
		careLoactionFeatures: (state) => state.careLoactionFeatures,
		careSpecialitiesPage: (state) => {
			const { $limit, $skip } = state.trustCareSpecialitiesListPagination;
			return $skip / $limit + 1;
		},
		featureSetupPage: (state) => {
			const { $limit, $skip } = state.trustFeatureSetupPagination;
			return $skip / $limit + 1;
		},
		adminSetupPage: (state) => {
			const { $limit, $skip } = state.trustAdminSetupPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_TRUSTS: (state, trusts) => { state.trusts = trusts; },
		SET_TRUST_LIST_FILTER: (state, filter) => { state.trustListFilter = { ...state.trustListFilter, ...filter }; },
		SET_TRUST_LIST_PAGINATION: (state, data) => { state.trustListPagination = { ...state.trustListPagination, ...data }; },
		SET_CURRENT_TRUST_ID: (state, trustId) => { state.currentTrustId = trustId; },
		SET_CARELOCATION_FEATURES: (state, data) => { state.careLoactionFeatures = data; },
		SET_CARE_SPECIALITIES_LIST: (state, data) => { state.trustCareSpecialitiesList = data; },
		SET_CARE_SPECIALITIES_LIST_PAGINATION: (state, data) => { state.trustCareSpecialitiesListPagination = { ...state.trustCareSpecialitiesListPagination, ...data }; },
		SET_CARE_SPECIALITIES_LIST_PAGINATION_FILTER: (state, filter) => { state.trustCareSpecialitiesListPaginationFilter = { ...state.trustCareSpecialitiesListPaginationFilter, ...filter }; },
		SET_TRUST_FEATURE_LIST: (state, data) => { state.trustFeatureList = data; },
		SET_FEATURE_SETUP_LIST_PAGINATION: (state, data) => { state.trustFeatureSetupPagination = { ...state.trustFeatureSetupPagination, ...data }; },
		SET_FEATURE_SETUP_LIST_PAGINATION_FILTER: (state, filter) => { state.trustFeatureSetupPaginationFilter = { ...state.trustFeatureSetupPaginationFilter, ...filter }; },
		SET_TRUST_ADMIN_LIST: (state, data) => { state.trustAdminList = data; },
		SET_ADMIN_SETUP_LIST_PAGINATION: (state, data) => { state.trustAdminSetupPagination = { ...state.trustAdminSetupPagination, ...data }; },
		SET_ADMIN_SETUP_LIST_PAGINATION_FILTER: (state, filter) => { state.trustAdminSetupPaginationFilter = { ...state.trustAdminSetupPaginationFilter, ...filter }; },
		SET_TRUST_SUMMARY_DATA: (state, data) => { state.trustSummaryData = { ...state.trustSummaryData, ...data }; },
		SET_DISABLE_CREATE: (state, data) => { state.disableCreate = { ...state.disableCreate, ...data }; },
		SET_GLOBAL_TRUST_FEATURE_LIST: (state, data) => { state.globalFeaturelist = data; },
		SET_IS_SWITCHING: (state, data) => { state.isSwitching = data; },
	},
	
	actions: {
		setFeatureSetupPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.trustFeatureSetupPagination.$limit;
			commit('SET_FEATURE_SETUP_LIST_PAGINATION', { $skip });
			commit('SET_FEATURE_SETUP_LIST_PAGINATION_FILTER', { $skip });
		},
		setFeatureListFilter: ({ commit }, filter) => {
			commit('SET_FEATURE_SETUP_LIST_PAGINATION_FILTER', filter);
		},
		setTtrustAdminList: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.trustAdminSetupPagination.$limit;
			commit('SET_ADMIN_SETUP_LIST_PAGINATION', { $skip });
			commit('SET_ADMIN_SETUP_LIST_PAGINATION_FILTER', { $skip });
		},
		setAdminListFilter: ({ commit }, filter) => {
			commit('SET_ADMIN_SETUP_LIST_PAGINATION_FILTER', filter);
		},
		setTrustListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.trustListPagination.$limit;
			commit('SET_TRUST_LIST_PAGINATION', { $skip });
			commit('SET_TRUST_LIST_FILTER', { $skip });
		},
		setTrustListFilter: ({ commit }, filter) => {
			commit('SET_TRUST_LIST_FILTER', filter);
		},
		setCareSpecilitiesPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.trustCareSpecialitiesListPagination.$limit;
			commit('SET_CARE_SPECIALITIES_LIST_PAGINATION', { $skip });
			commit('SET_CARE_SPECIALITIES_LIST_PAGINATION_FILTER', { $skip });
		},
		setCareSpecilitiesFilter: ({ commit }, filter) => {
			commit('SET_CARE_SPECIALITIES_LIST_PAGINATION_FILTER', filter);
		},
		createTrust: async ({ rootGetters }, trust) => {
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).create(trust, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadNewTrusts: async ({ commit }, filter) => {
			const test = filter.searchText;
			delete filter.searchText;
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).find({ query: { fields: ['info'], ...filter, $search: test } });
			commit('SET_TRUSTS', results.data);
			const totalCount = results.total;
			commit('SET_TRUST_LIST_PAGINATION', { total: totalCount });
			return results;
		},
		updateTrust: async ({ rootGetters }, trust) => {
			const id = trust.id;
			delete trust.id;
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).patch(id, trust, { query: { $role: rootGetters.currentUserRole } });
			
			return results;
		},
		getHeirarchyOfTrust: async (context, trustId) => {
			const url = '/api/v3/adminstrative-groups';
			const results = await feathersClient.service(url).find({ query: { $isTop: true, trustId: trustId } });
			return results;
		},
		getTrustHeirarchy: async (context, trustId) => {
			const url = '/api/v3/trust-heirarchy';
			const results = await feathersClient.service(url).find({ query: { trustId: trustId } });
			return results;
		},
		getTrustHeirarchySearch: async (context, filter) => {
			const url = '/api/v3/trust-heirarchy';
			const results = await feathersClient.service(url).find({ query: { ...filter } });
			return results;
		},
		addNewAdminGroups: async ({ rootGetters }, adminGroup) => {
			const url = '/api/v3/adminstrative-groups';
			const results = await feathersClient.service(url).create(adminGroup, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getAdminGroupById: async (context, id) => {
			const url = '/api/v3/adminstrative-groups';
			const results = await feathersClient.service(url).get(id);
			return results;
		},
		getTrustById: async (context, id) => {
			if (id) {
				const results = await feathersClient.service('/api/v3/trusts').get(id, {
					query: {
						fields: ['info'],
					},
				}).catch((err) => {

				});
				return results;
			}
		},
		updateAdminGroup: async ({ rootGetters }, adminGroup) => {
			const url = '/api/v3/adminstrative-groups';
			const results = await feathersClient.service(url).patch(adminGroup.id, adminGroup, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteAdminGroup: async ({ rootGetters }, id) => {
			const url = '/api/v3/adminstrative-groups';
			const results = await feathersClient.service(url).remove(id, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		addNewCareLocation: async ({ rootGetters }, carelocation) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).create(carelocation, { query: { $role: rootGetters.currentUserRole, $ProvidePermissionsFromParentGroup: true } });
			return results;
		},
		getCareLocationById: async (context, id) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).get(id, { query: { fields: ['CreateJobCarespeciallities'] } });
			return results;
		},
		getCareLocationByIdWithMApping: async (context, id) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).get(id, { query: { fields: ['CreateJobCarespeciallities','optimaMappings'] } });
			return results;
		},
		updateCareLocation: async ({ rootGetters }, carelocation) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).patch(carelocation.id, carelocation, { query: { $role: rootGetters.currentUserRole, $RetainCareLocationPermissions: true } });
			return results;
		},
		deleteCareLocation: async ({ rootGetters }, id) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).remove(id, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		setCurrentTrustId: ({ commit }, trustId) => {
			commit('SET_CURRENT_TRUST_ID', trustId);
		
		},
		getWeightAdjuster: async ({ rootGetters }) => {
			const url = '/api/v3/staffmatchweightsettings';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		createWeightAdjuster: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffmatchweightsettings';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateWeightAdjuster: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffmatchweightsettings';
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getCareLocationFeatureConfig: async({ rootGetters, commit }, filter) => {
			const result = await feathersClient.service('/api/v3/carelocation-feature-configurations').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			if (result.data.length === 0) {
				const obj = {
					configurationName: 'Auto Offer',
					configurationValue: false,
				};
				result.data.push(obj);
			}
			commit('SET_CARELOCATION_FEATURES', result.data);
			return result.data;
		},
		updateCareLocationFeaturebyId: async({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const result = await feathersClient.service('/api/v3/carelocation-feature-configurations').patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return result;
		},
		createCareLocationFeature: async({ rootGetters }, data) => {
			const result = await feathersClient.service('/api/v3/carelocation-feature-configurations').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return result;
		},
		getShiftsForTrust: async ({ rootGetters }, data) => {
			const response = await feathersClient.service('api/v3/shifttimes').find({
				query: {
					$role: rootGetters.currentUserRole,
					careLocationId: [data],
					$paginate: false,
				},
			});
			return response;
		},
		getShifts: async ({ rootGetters }, data) => {
			const response = await feathersClient.service('api/v3/shifttimes').find({
				query: {
					$role: rootGetters.currentUserRole,
					careLocationId: [data],
				},
			});
			return response.data;
		},
		saveShifts: async ({ rootGetters }, data) => {
			const url = '/api/v3/shifttimes';
			const results = await feathersClient.service(url).create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		deleteShifts: async ({ rootGetters }, id) => {
			const url = '/api/v3/shifttimes/';
			await feathersClient.service(url).remove(id, { query: { $role: rootGetters.currentUserRole } });
		},
		updateShift: async ({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const url = '/api/v3/shifttimes';
			const results = await feathersClient.service(url).patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getTrustCareSpecialities: async({ rootGetters, commit }, filter) => {
			if (rootGetters.currentUserRolePermissions?.includes('VIEW_TRUST_CARE_SPECIALITIES')) {
				const result = await feathersClient.service('/api/v3/trust-care-specialities').find({
					query: {
						$role: rootGetters.currentUserRole,
						fields: ['careSpecialityType'],
						...filter,
					},
				});
				commit('SET_CARE_SPECIALITIES_LIST_PAGINATION', { total: result.total });
				commit('SET_CARE_SPECIALITIES_LIST', result.data);
				return result;
			}
		},
		updateCareSpecialityStatus: async({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const url = '/api/v3/trust-care-specialities';
			const results = await feathersClient.service(url).patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getAllCareLocationForTrust: async({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/care-locations').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
					$paginate: false,
				},
			});
			return results;
		},
		getAllCareLocationForTrustIsMasterShiftTemplateUsed: async({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/care-locations').find({
				query: {
					$role: rootGetters.currentUserRole,
					$getCareLocation: true,
					...filter,
					$paginate: false,
				},
			});
			return results;
		},
		getAllGroupShiftsForTrust: async ({ rootGetters }) => {
			const response = await feathersClient.service('api/v3/shifttimes').find({
				query: {
					$role: rootGetters.currentUserRole,
					$getShitTemplate: true,
					fields: ['shiftTimes'],

				},
			});
			return response;
		},
		updateCareLocationById: async({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/care-locations').patch(data.id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getTrustStats: async({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/trust-statistics').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			return results;
		},
		getTrustFeatureSetupList: async({ rootGetters, commit }, filter) => {
			const result = await feathersClient.service('/api/v3/trust-feature-settings').find({
				query: {
					$role: rootGetters.currentUserRole,
					$sortedList:true,
					isShow: true,
					...filter,
				},
			});
			commit('SET_FEATURE_SETUP_LIST_PAGINATION', { total: result.total });
			commit('SET_TRUST_FEATURE_LIST', result.data);
		},
		getAllFeatureList: async({ rootGetters }, filter) => {
			const result = await feathersClient.service('/api/v3/feature-lists').find({
				query: {
					$role: rootGetters.currentUserRole,
					$paginate: false,
					$sort:{name:1},
					isShow: true,
					...filter,
				},
			});
		
			return result;
		},
		getTrustAdminList: async({ rootGetters, commit }, id) => {
			if (id) {
				const result = await feathersClient.service('/api/v3/trusts').get(id, {
					query: {
						fields: ['info'],
					},
				});
				if (result.total) {
					commit('SET_ADMIN_SETUP_LIST_PAGINATION', { total: result.total });
				}
				commit('SET_TRUST_ADMIN_LIST', result);
			}
		},
		isTrustAdminEmailExists: async ({ rootGetters }, data) => {
			const result = await feathersClient.service('/api/v3/users').find({
				query: {
					email: data.toLowerCase(),
				},
			});
			return result;
		},
		getGlobalTrustFeatureSetupList: async({ rootGetters, commit }, filter) => {
			const result = await feathersClient.service('/api/v3/trust-feature-settings').find({
				query: {
					$role: rootGetters.currentUserRole,
					$paginate: false,
					isEnabled: true,
					isPurchased: true,
					isShow: true,
					...filter,
				},
			});
			const filterList = result.map((item) => {
				if (item.featuresData) {
					return item.featuresData.name;
				}
			});
			commit('SET_GLOBAL_TRUST_FEATURE_LIST', filterList);
		},
		updateTrustAdmin: async({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const result = await feathersClient.service('/api/v3/trusts').patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
					$trustAdmin: true,
				},
			});
			return result;
		},
		getAllFeatureListFrSuperAdmin: async ({ rootGetters, commit }, filter) => {
			const result = await feathersClient.service('/api/v3/feature-lists').find({
				query: {
					$role: rootGetters.currentUserRole,
					$sort:{name:1},
					isShow: true,
					...filter,
				},
			});
			commit('SET_FEATURE_SETUP_LIST_PAGINATION', { total: result.total });
			commit('SET_TRUST_FEATURE_LIST', result.data);
			return result;
		},
		getVideoInfo: async (context, videoUrl) => {
			const results = await feathersClient.service('/api/v3/youtube-video-info').find({
				query: {
					videoUrl: videoUrl,
				},
			});
			return results;
		},
		checktrustEmail: async ({ state }) => {
			const email = state.trustSummaryData?.email;
			const results = await feathersClient.service('/api/v3/trusts').find({
				query: {
					email: email.toLowerCase(),
				},
			});
			if (results?.data?.length > 0) {
				return true;
			}
			return false;
		},
		getOptimaUnitTypes: async ({rootGetters, state }, filter) => {
			const results = await feathersClient.service('/api/v3/optima-mappings').find({
				query: {
					$role:rootGetters.currentUserRole,
					$getUnits: true,
					...filter,
				},
			});
			
			return results;
		},
		updateTrustCode:async ({rootGetters,state},data) =>{
			const results = await feathersClient.service('/api/v3/optima-mappings').create(data,{
				query:{
					$updateTrustCode:true,
					$role:rootGetters.currentUserRole,
				},
			});
			return results
		}
	},
};
